var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 150 150",
    fill: "#025add",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m115.307 34.25h-22.25a1 1 0 0 1 -1-1v-22.25a1 1 0 0 1 1.707-.707l22.25 22.25a1 1 0 0 1 -.707 1.707zm-21.25-2h18.836l-18.836-18.836z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m115.307 140h-102.25a1 1 0 0 1 -1-1v-128a1 1 0 0 1 1-1h80a1 1 0 0 1 .707.293l22.25 22.25a1 1 0 0 1 .293.707v105.75a1 1 0 0 1 -1 1zm-101.25-2h100.25v-104.336l-21.664-21.664h-78.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m58.14 22.167h-36.333a1 1 0 0 1 0-2h36.333a1 1 0 0 1 0 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58.14 32.5h-36.333a1 1 0 0 1 0-2h36.333a1 1 0 0 1 0 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m107.307 49.418h-86.25a1 1 0 1 1 0-2h86.25a1 1 0 0 1 0 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m107.307 61h-86.25a1 1 0 0 1 0-2h86.25a1 1 0 1 1 0 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m107.307 72.582h-86.25a1 1 0 0 1 0-2h86.25a1 1 0 1 1 0 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m64.182 127.5a23 23 0 1 1 23-23 23.026 23.026 0 0 1 -23 23zm0-44a21 21 0 1 0 21 21 21.024 21.024 0 0 0 -21-21z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m64.182 122.324a18.05 18.05 0 1 1 18.05-18.05 18.07 18.07 0 0 1 -18.05 18.05zm0-34.1a16.05 16.05 0 1 0 16.05 16.05 16.068 16.068 0 0 0 -16.05-16.05z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m59.657 111.777a1 1 0 0 1 -.707-.293l-3.856-3.856a1 1 0 1 1 1.414-1.414l3.149 3.149 12.2-12.2a1 1 0 0 1 1.414 1.414l-12.907 12.907a1 1 0 0 1 -.707.293z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m136.943 126.051a1 1 0 0 1 -1-1v-65.426h-12.169v65.426a1 1 0 0 1 -2 0v-66.426a1 1 0 0 1 1-1h14.169a1 1 0 0 1 1 1v66.426a1 1 0 0 1 -1 1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m136.943 59.625a1 1 0 0 1 -1-1v-9.762a3.2 3.2 0 0 0 -3.2-3.2h-5.773a3.2 3.2 0 0 0 -3.2 3.2v9.762a1 1 0 0 1 -2 0v-9.762a5.2 5.2 0 0 1 5.2-5.2h5.776a5.2 5.2 0 0 1 5.2 5.2v9.762a1 1 0 0 1 -1.003 1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m129.858 139.925a1 1 0 0 1 -.891-.545l-7.084-13.874a1 1 0 0 1 .426-1.34 15.436 15.436 0 0 1 15.1 0 1 1 0 0 1 .425 1.34l-7.085 13.874a1 1 0 0 1 -.891.545zm-5.732-14.425 5.732 11.226 5.732-11.226a13.115 13.115 0 0 0 -11.464 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m129.859 124.193a1 1 0 0 1 -1-1v-64.568a1 1 0 0 1 2 0v64.568a1 1 0 0 1 -1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.2216f9f5fc5855778b70331e345369d3.svg";
export { ForwardRef as ReactComponent };